import React from 'react';
import { DepartmentSummary } from '../types';

interface Props {
  departments: DepartmentSummary[];
  onDepartmentClick?: (departmentId: number) => void;
}

export const DepartmentsTable: React.FC<Props> = ({ departments, onDepartmentClick }) => {
  if (departments.length === 0) {
    return null;
  }

  return (
    <div style={{ border: '1px solid #e5e7eb', borderRadius: 12, overflow: 'hidden' }}>
      <div style={{ padding: '20px 24px 16px' }}>
        <span style={{ fontSize: 14, fontWeight: 500, color: '#111827', display: 'block' }}>Departments</span>
      </div>

      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr
              style={{ backgroundColor: '#f9fafb', borderTop: '1px solid #f3f4f6', borderBottom: '1px solid #f3f4f6' }}
            >
              <th style={{ textAlign: 'left', fontSize: 12, fontWeight: 500, color: '#6b7280', padding: '8px 24px' }}>
                Department
              </th>
              <th style={{ textAlign: 'right', fontSize: 12, fontWeight: 500, color: '#6b7280', padding: '8px 24px' }}>
                Total Users
              </th>
              <th style={{ textAlign: 'right', fontSize: 12, fontWeight: 500, color: '#6b7280', padding: '8px 24px' }}>
                Active (30d)
              </th>
              <th style={{ textAlign: 'right', fontSize: 12, fontWeight: 500, color: '#6b7280', padding: '8px 24px' }}>
                Active (90d)
              </th>
              <th style={{ textAlign: 'right', fontSize: 12, fontWeight: 500, color: '#6b7280', padding: '8px 24px' }}>
                Active (365d)
              </th>
              <th style={{ textAlign: 'right', fontSize: 12, fontWeight: 500, color: '#6b7280', padding: '8px 24px' }}>
                New (30d)
              </th>
              <th
                style={{
                  textAlign: 'right',
                  fontSize: 12,
                  fontWeight: 500,
                  color: '#6b7280',
                  padding: '8px 24px',
                  width: 160,
                }}
              >
                Activity Rate
              </th>
            </tr>
          </thead>
          <tbody>
            {departments.map((dept) => {
              const activityRate = dept.total_users > 0 ? (dept.active_last_30_days / dept.total_users) * 100 : 0;
              const rateFormatted = activityRate.toFixed(0);

              return (
                <tr
                  key={dept.id}
                  onClick={() => onDepartmentClick?.(dept.id)}
                  style={{
                    borderBottom: '1px solid #f9fafb',
                    cursor: onDepartmentClick ? 'pointer' : 'default',
                    transition: 'background-color 0.1s',
                  }}
                  onMouseEnter={(e) => {
                    if (onDepartmentClick) e.currentTarget.style.backgroundColor = '#f0f9ff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '';
                  }}
                >
                  <td style={{ padding: '10px 24px', fontSize: 13, color: '#111827' }}>{dept.name}</td>
                  <td
                    style={{
                      padding: '10px 24px',
                      fontSize: 13,
                      color: '#374151',
                      textAlign: 'right',
                      fontVariantNumeric: 'tabular-nums',
                    }}
                  >
                    {dept.total_users}
                  </td>
                  <td
                    style={{
                      padding: '10px 24px',
                      fontSize: 13,
                      color: '#374151',
                      textAlign: 'right',
                      fontVariantNumeric: 'tabular-nums',
                    }}
                  >
                    {dept.active_last_30_days}
                  </td>
                  <td
                    style={{
                      padding: '10px 24px',
                      fontSize: 13,
                      color: '#374151',
                      textAlign: 'right',
                      fontVariantNumeric: 'tabular-nums',
                    }}
                  >
                    {dept.active_last_90_days}
                  </td>
                  <td
                    style={{
                      padding: '10px 24px',
                      fontSize: 13,
                      color: '#374151',
                      textAlign: 'right',
                      fontVariantNumeric: 'tabular-nums',
                    }}
                  >
                    {dept.active_last_365_days}
                  </td>
                  <td
                    style={{
                      padding: '10px 24px',
                      fontSize: 13,
                      color: '#374151',
                      textAlign: 'right',
                      fontVariantNumeric: 'tabular-nums',
                    }}
                  >
                    {dept.new_users_last_30_days}
                  </td>
                  <td style={{ padding: '10px 24px', textAlign: 'right' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 8 }}>
                      <div style={{ width: 56, backgroundColor: '#f3f4f6', borderRadius: 99, height: 4 }}>
                        <div
                          style={{
                            height: 4,
                            borderRadius: 99,
                            width: `${Math.min(activityRate, 100)}%`,
                            backgroundColor: '#60a5fa',
                          }}
                        />
                      </div>
                      <span
                        style={{
                          fontSize: 12,
                          color: '#6B7280',
                          width: 32,
                          textAlign: 'right',
                          fontVariantNumeric: 'tabular-nums',
                        }}
                      >
                        {rateFormatted}%
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
